import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import AdminActionButton from '../admin-action/AdminActionButton'
import { AdminActionEnum } from '../admin-action/utils/admin-action-data'
import PingPongButton from '../../buttons-by-step/PingPongButton'
import { PingPongButtonTypeEnum } from '../../utils/ping-pong-button-type.enum.ts'
import { ClientProposalOutputDto } from '../../../../../../lib/graphql'
import { IProposalInteractionsProps } from '../../../Proposal'

interface IPostBalancePaidFooterProps {
  adminActions: IProposalInteractionsProps['adminActions']
  clientProposal: Pick<ClientProposalOutputDto, '_id' | 'permissions'>
}

const PostBalancePaidFooter = ({
  adminActions,
  clientProposal,
}: IPostBalancePaidFooterProps) => {
  const adminCanceledPostBalanceAdjustmentsConfirmation =
    adminActions?.adminCanceledPostBalanceAdjustmentsConfirmation

  const intl = useIntl()

  const redirectRatingPage = () => {
    window.open(
      intl.formatMessage({
        id: 'ui.PostBalancePaidFooter.feedbackFormUrl',
        defaultMessage:
          'https://survey.hsforms.com/1uqspkLlGQ1GrKjfrmNLgLwclz87',
      }),
      '_blank',
    )
  }

  return (
    <div className='flex w-full flex-col gap-3 py-5'>
      <PingPongButton
        type={PingPongButtonTypeEnum.PAYMENT_DONE}
        label={
          <FormattedMessage
            id='ui.PostBalancePaidFooter.postBalancePaid'
            defaultMessage='Solde post-séjour réglé'
          />
        }
      />
      <PingPongButton
        type={PingPongButtonTypeEnum.GIVE_FEEDBACK}
        label={
          <FormattedMessage
            id='ui.PostBalancePaidFooter.giveFeedback'
            defaultMessage='Donnez votre avis sur le séjour'
          />
        }
        onClick={redirectRatingPage}
      />
      {clientProposal.permissions.canCancelStepSeven &&
        adminCanceledPostBalanceAdjustmentsConfirmation && (
          <AdminActionButton
            adminAction={
              AdminActionEnum.CANCEL_POST_BALANCE_ADJUSTMENTS_CONFIRMATION
            }
            onClickConfirm={() =>
              adminCanceledPostBalanceAdjustmentsConfirmation.callback({
                clientProposalId: clientProposal._id,
              })
            }
            isLoading={
              adminCanceledPostBalanceAdjustmentsConfirmation.isLoading
            }
          />
        )}
    </div>
  )
}

export default PostBalancePaidFooter
